import {useQuery} from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";
import {sortCountries} from "../utils/countriesHelpers";

export const useGetCountries = () => {
    const {
        isFetching: isLoading, data: countries, error,
    } = useQuery({
        queryKey: ["countries"],
        queryFn: () => axiosManager.get$("countries").then((response) => response?.data),
        initialData: [],
        retry: 0,
    });

    const countriesOptions = sortCountries((countries || []).map((item) => ({value: item.code, label: item.name})));
    const phoneCodeOptions = sortCountries((countries || []).map((item) => ({value: item.code, label: item.name, code: item.internationalDialingCode})));
    const phoneCodeOnlyOptions = sortCountries((countries || []).map((item) => ({value: item.code, label: `+${item.internationalDialingCode}`})))
        .map((item) => ({value: item.label, label: item.label}))
        .filter((obj, index, self) => index === self.findIndex((t) => t.value === obj.value));

    return {
        isLoading, countries, error, countriesOptions, phoneCodeOptions, phoneCodeOnlyOptions,
    };

};
